import React from 'react'
import { EmptyContent as MessageEmptyContent } from '@ztechapps/chat.webui'
import { AddNewConversationButton } from './AddNewConversationButton'
export const EmptyContent = () => {
  return <MessageEmptyContent action={<AddNewConversationButton />} icon={'comments'} />
}
